import { Icon } from '@iconify/react'
import { Table, TableHeader, TableColumn, TableBody, TableRow, TableCell, Button } from '@nextui-org/react'
import { IconPlus } from '@tabler/icons-react'

export default function TenderAttachments({ attachments }) {
  return (
    <div className="pt-4">
      <Table>
        <TableHeader>
          <TableColumn>Document Name</TableColumn>
          <TableColumn> </TableColumn>
        </TableHeader>
        <TableBody
          items={attachments ?? []}
          emptyContent={
            <div className="flex flex-col gap-2 mt-2 bg-white rounded-xl justify-center items-center">
              <div className={'flex flex-col justify-center items-center p-4'}>
                <div className={'bg-white p-2 rounded-full mb-2'}>
                  <Icon icon={'lucide:cloud-upload'} />
                </div>
                <p className={'font-regular text-sm'}>
                  <span className={'pr-1 font-medium text-blue-400 cursor-pointer'}>
                    No Attachment file was found for this tender.
                  </span>
                </p>
              </div>
            </div>
          }
        >
          {attachments?.map((item: any) => (
            <TableRow key={`attachment_${item.uuid}`} className="border-b-1 border-b-balck-500">
              <TableCell onClick={() => window.open(item.url, '_blank')} className=" cursor-pointer">
                <span className="text-sm text-black-500 font-medium underline">{item.filename ?? '-'}</span>
              </TableCell>
              <TableCell>
                <Button
                  variant="light"
                  className="focus:none data-[state=open]:bg-muted text-muted-foreground flex size-8"
                >
                  <span className="flex flex-row gap-2 items-center" onClick={() => window.open(item.url, '_blank')}>
                    <Icon icon={'lucide:download'} color="#38A1B1" />
                    Download
                  </span>
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
